import "./style.css";

export default () => (
  <div className="loading">
    <div className="lds-ripple">
      <div />
      <div />
    </div>
  </div>
);
